import React from 'react';
import './ProductPlaceholderArt.css';

const TONES = ['blue', 'stone', 'sage', 'rose'];

const stableTone = (value) => {
  const text = String(value || 'product').toLowerCase();
  let hash = 0;
  for (let i = 0; i < text.length; i += 1) hash = (hash * 31 + text.charCodeAt(i)) | 0;
  return TONES[Math.abs(hash) % TONES.length];
};

const inferShape = (name) => {
  const text = String(name || '').toLowerCase();
  if (/cream|lotion|cleanser|sunscreen|spf|balm|gel/.test(text)) return 'tube';
  if (/cushion|compact|powder/.test(text)) return 'compact';
  return 'bottle';
};

// A clearly illustrated stand-in for a missing approved hero image. It never
// substitutes a shade swatch or claims to depict the actual product packaging.
export default function ProductPlaceholderArt({ name = '', brand = '', tone, kind }) {
  const colour = TONES.includes(tone) ? tone : stableTone(brand || name);
  const shape = kind || inferShape(name);
  const label = String(brand || '').trim() || 'Product';

  return (
    <span className={`product-placeholder-art product-placeholder-art--${colour}`} role="img" aria-label={`Illustrated placeholder for ${name || 'product'}; product image unavailable`}>
      <span className={`product-placeholder-art__pack product-placeholder-art__pack--${shape}`} aria-hidden="true">
        <span className="product-placeholder-art__label">{label}</span>
        <span className="product-placeholder-art__rule" />
      </span>
    </span>
  );
}
